import React from 'react';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
  showIcon?: boolean;
}
export function Button({
  children,
  fullWidth = false,
  size = 'lg',
  showIcon = true,
  className = '',
  ...props
}: ButtonProps) {
  const sizeClasses = {
    md: 'px-6 py-3 text-sm tracking-wide',
    lg: 'px-8 py-4 text-base md:text-lg tracking-wide',
    xl: 'px-10 py-5 text-lg md:text-xl font-semibold uppercase tracking-wider'
  };
  return <button className={`
        relative inline-flex items-center justify-center gap-3 
        bg-terracotta-gradient text-white font-medium rounded-full 
        transition-all duration-500 transform hover:-translate-y-1 hover:shadow-premium-hover
        active:scale-95 shadow-premium overflow-hidden group
        ${fullWidth ? 'w-full' : ''} 
        ${sizeClasses[size]} 
        ${className}
      `} {...props} data-id="element-58">
      {/* Shine effect overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shine-sweep_1.5s_ease-in-out] pointer-events-none" data-id="element-59"></div>

      <span className="relative z-10 drop-shadow-sm" data-id="element-60">{children}</span>
      {showIcon && <ChevronRight className="w-5 h-5 relative z-10 transition-transform duration-300 group-hover:translate-x-1" data-id="element-61" />}
    </button>;
}